<template>
    <div class="main-contact" id="Contact">
        <div class="group-title">
            <h1 class="title-h1">Contacto</h1>
        </div>
        <div class="group-contact">
            <div class="group-left">
                <div class="group-text">
                    <h1>Puedes contactar conmigo desde este formulario 👋</h1>
                </div>
    
                <form @submit.prevent="sendEmail" class="form">
                    <div class="group-name-email">
                        <div class="group-name">
                            <p>Nombre</p>
                            <input type="text" v-model="name" required> 
                        </div>
                        <div class="group-email">
                            <p>Email</p>
                            <input type="email" v-model="email" required>
                        </div>
                    </div>
                    <p>Asunto</p>
                    <input type="text" v-model="subject" required>
                    <p>Mensaje</p>
                    <textarea v-model="message" id="" cols="30" rows="10" required></textarea>
                    <div class="div-button">
                        <button type="submit" class="send-button">Enviar </button>
                    </div>
                </form>
    
            </div>
            <div class="group-right">     
                <h1>Dirección</h1>
                <p>Sevilla, Andalucia, España</p>
    
                <h1>Email</h1>
                <p>lidiaholgadodev@gmail.com</p>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      email: '',
      subject: '',
      message: ''
    };
  },
  methods: {
    async sendEmail() {
      try {
        console.log('Enviando datos:', {
          name: this.name,
          email: this.email,
          subject: this.subject,
          message: this.message
        }); // Log para verificar los datos

        const response = await fetch('http://localhost:3000/send-email', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            name: this.name,
            email: this.email,
            subject: this.subject,
            message: this.message
          })
        });

        if (response.ok) {
          alert('Correo enviado con éxito');
          this.name = '';
          this.email = '';
          this.subject = '';
          this.message = '';
        } else {
          alert('Error al enviar el correo');
        }
      } catch (error) {
        alert('Error al enviar el correo');
      }
    }
  }
};
</script>

<style scoped>

    .main-contact{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        
    }
    .group-title{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        margin-bottom: 4em;
    }

    .title-h1{
        font-family: Roboto;
        font-size: 3em;
    }

    .group-contact{
        display: grid;
        grid-template-columns: 2fr 1fr;
        width: 100%;

    }
    .group-name-email{
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
    }

    .group-name{
        display: flex;
        flex-direction: column;
        width: 45%;
    }

    .group-email{
        display: flex;
        flex-direction: column;
        width: 45%;
    }

    .group-left{
        display: flex;
        flex-direction:column;
        justify-content: center;
        align-items: center;
        background-color: #faf3e1;

    }
    
    .form{
        display: flex;
        flex-direction: column;
        width: 75%;

        p{
        font-family: Roboto;
        margin-bottom: 0.1em; 
    }
    }

    input{
        height: 2em;
        border: 2px solid #000;
        border-radius: 0.2em;
        background: #fdf9f8;
        margin-bottom: 1em;
    }

    textarea{
        border: 2px solid #000;
        border-radius: 0.2em;
        background: #fdf9f8;
    }
    .group-right{
        display: flex;
        flex-direction:column;
        justify-content: center;
        align-items: center;
        background-color: #faf3e1;
    }

    .group-right h1{
        font-family:Caveat;
        color: #78c2a7;
        font-size: 2em;
    }

    .div-button{
        display: flex;
        flex-direction: column;
        justify-content:flex-end;
        align-items:flex-end;;
    }

    .send-button{
        width: 15em;
        height: 2em;
        background-color: #222222;
        color: #fff;
        border: none;
        border-radius: 0.2em;
        font-family: Roboto;
        font-size: 1em;
        cursor: pointer;
        margin-top: 1em;
        margin-left: auto;
    }
    
</style>